import React from "react";
import { defaultLogoSize } from "../../../config";
import { Box } from "@material-ui/core";

export default function Logo({
  height = defaultLogoSize,
  width = defaultLogoSize,
}) {
  const nemuruLogoAspectRatio = 0.4;
  const nemuruLogoHeight = nemuruLogoAspectRatio * width;
  return (
    <Box
      color="primary.main"
      style={{ width: "100%", height: `${nemuruLogoHeight}px` }}
    >
      <i
        className="icon-nemuru-logo mr1"
        style={{
          fontSize: `${width}px`,
          lineHeight: `${nemuruLogoHeight}px`,
        }}
      />
    </Box>
  );
}
